import {
  Menu,
  MenuTrigger,
  MenuPopover,
  Button,
} from "@fluentui/react-components";
import {
  Calendar20Regular,
  ChevronDown20Regular,
} from "@fluentui/react-icons";
import { useState, useEffect } from "react";
import moment from "moment";
import ASCButton from "../Button";
import DynamicDatePicker from "../ControlledDatePicker/dynamicDatepicker";

export const DropdownDatepicker = (props: any) => {
  const [open, setOpen] = useState(false);

  const options = [
    { label: "Define Dates", value: "defineDates" },
    { label: "All Dates", value: "allDates" },
    { label: "Past Dates", value: "pastDate" },
    { label: "Today Plus Overdue", value: "todayDateOverdue" },
    { label: "Next 7 Days Plus Overdue", value: "next7DaysOverdue" },
    { label: "Next 31 Days Plus Overdue", value: "next31DaysOverdue" },
    { label: "This Year Plus Overdue", value: "thisYearOverdue" },
  ];

  const optionMap: Record<string, string> = Object.fromEntries(
    options.map((o) => [o.value, o.label])
  );

  const [context, setContext] = useState<string>("");
  const [contextLabel, setContextLabel] = useState<string>(
    props.optionDateValue || ""
  );
  const [startDate, setStartDate] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");
  const [optionDate, setOptionDate] = useState("");

  /* ================= DEFINE DATE BUILD ================= */
  useEffect(() => {
    if (context === "defineDates" && startDate && endDate) {

      let newOption = `defineDates&start_date=${startDate !== "" ? moment(startDate).format("YYYY-MM-DD[T00:00:00.000Z]") : ""
        }&end_date=${endDate !== "" ? moment(endDate).format("YYYY-MM-DD[T00:00:00.000Z]") : ""
        }`;
      setOptionDate(newOption);
    }
  }, [startDate, endDate, context]);

  /* ================= SYNC SAVED VALUE ================= */
  useEffect(() => {
    if (props.optionDate) {
      if (props.optionDate.includes("defineDates")) {
        setContext("defineDates");

        const params = new URLSearchParams(
          props.optionDate.split("&").slice(1).join("&")
        );

        const start = params.get("start_date");
        const end = params.get("end_date");


        setStartDate(start);
        setEndDate(end);
        if (start && end) {
          setContextLabel(
            `${moment(start).format("DD MMM YYYY")} - ${moment(end).format(
              "DD MMM YYYY"
            )}`
          );
        } else {
          setContextLabel("Define Dates");
        }
      } else {
        setContext(props.optionDate);
        setContextLabel(optionMap[props.optionDate] || "Select Date");
      }
    }
  }, [props.optionDate]);

  /* ================= HANDLE SELECT ================= */
  const handleSelect = (value: string, label: string) => {
    setContext(value);
    setContextLabel(label);

    if (value !== "defineDates") {
      setOptionDate(value);

      // ✅ Apply immediately
      props.dateSelection(value);
      props.dateLabel(label);
      setOpen(false);
    }
  };

  return (
    <Menu open={open} onOpenChange={(_, d) => setOpen(d.open)}>
      {/* ================= BUTTON ================= */}
      <MenuTrigger disableButtonEnhancement>
        <Button
          appearance="outline"
          icon={<Calendar20Regular />}
          style={{ width: 260 }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {contextLabel || "Select Date"}
            <ChevronDown20Regular />
          </div>
        </Button>
      </MenuTrigger>

      {/* ================= MENU ================= */}
      <MenuPopover style={{ padding: "15px", maxWidth: 260, overflowX: "visible" }}>
        {/* 🔙 BACK BUTTON */}
        {context === "defineDates" && (
          <div
            onClick={() => setContext("")}
            style={{
              cursor: "pointer",
              color: "#0078d4",
              marginBottom: "6px",
              fontSize: "12px",
            }}
          >
            ← Back
          </div>
        )}

        {/* ================= OPTIONS ================= */}
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {(context === "defineDates"
            ? options.filter((o) => o.value === "defineDates")
            : options
          ).map((opt) => (
            <div
              key={opt.value}
              onClick={() => handleSelect(opt.value, opt.label)}
              style={{
                padding: "6px 10px",
                borderRadius: "4px",
                cursor: "pointer",
                background:
                  context === opt.value ? "#f3f2f1" : "transparent",
                fontWeight: context === opt.value ? 600 : 400,
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>

        {/* ================= DATE PICKERS ================= */}
        {context === "defineDates" && (
          <div style={{ marginTop: "10px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <DynamicDatePicker
                label="Start Date"
                name="startDate"
                width="230px"
                formik={{
                  values: { startDate },
                  setFieldValue: (_: string, value: any) => {
                    if (value) setStartDate(value);
                  },
                  setFieldTouched: () => { },
                  setFieldError: () => { },
                  errors: {},
                  touched: {},
                }}
              />

              <DynamicDatePicker
                label="End Date"
                name="endDate"
                width="230px"
                formik={{
                  values: { endDate },
                  setFieldValue: (_: string, value: any) => {
                    if (value) setEndDate(value);
                  },
                  setFieldTouched: () => { },
                  setFieldError: () => { },
                  errors: {},
                  touched: {},
                }}
              />
            </div>

            {/* ================= SELECT BUTTON ================= */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
              }}
            >
              <ASCButton
                shape="rounded"
                appearance="primary"
                className="asc-button-primary"
                onClick={() => {
                  props.dateSelection(optionDate);
                  props.dateLabel(contextLabel);
                  setOpen(false);
                }}
                label="Select"
              />
            </div>
          </div>
        )}
      </MenuPopover>
    </Menu>
  );
};